import Component from 'gia/Component';

import { gsap } from "gsap";


export default class FormationToggle extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      button: {},
      texte: {}
    };
  }

  mount() {
    let that = this;
    this.ref.button.addEventListener('click', function(e) {
      if (that.ref.button.classList.contains('active')) {
        that.closeToggle();
      } else {
        that.openToggle();
      }
    })
  }


  closeToggle() {
    let that = this;
    let texte = that.ref.texte;
    let button = this.ref.button;
    button.classList.remove('active');
    let timeline = gsap.timeline();
    timeline.to(texte, {height: 0, duration: 0.5});
  }

  openToggle() {
    let that = this;
    let texte = this.ref.texte;
    let button = this.ref.button;
    button.classList.add('active');
    let height = texte.offsetHeight;
    // gsap.set(container, {height: height});
    let timeline = gsap.timeline();
    timeline.to(texte, {height: 'auto', duration: 0.5});
  }
}